export default "__VITE_ASSET__37bd051d__"